<template>
    <div ref="el" :class="upgrade.toLowerCase()">{{ upgrade[0] }}</div>
    <ToolTip :message="upgrade" :anchor="el" />
</template>

<script setup>
import ToolTip from "@/components/ToolTip.vue";
import { ref } from 'vue';

const el = ref(null);

const props = defineProps({
    participants: Object,
    upgrade: String
});
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';


div {
    display: inline-block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    color: white;
    font-style: normal;
    border: 1px solid $lightIndigo;

    &.byte {
        background: #34b46a;
        background-image: $badgeByteGradient;
    }

    &.kilo {
        background: $gold;
        background-image: $badgeKiloGradient;
    }

    &.mega {
        background: $purple;
        background-image: $badgeMegaGradient;
    }

    &.giga {
        background: $teal;
        background-image: $badgeGigaGradient;
    }
}
</style>